angular.module('am4')
.factory('serviceRequestService', function($http, apiUrl) {
    return {
        postServiceRequest: function(frame_serial, requestInfo) {
            return $http.post(apiUrl + '/machines/' + frame_serial + '/servicerequest', requestInfo)
            .then(function(res) {
                return res.data;
            });
        },
        getServiceRequests: function(frame_serial) {
            return $http.get(apiUrl + '/machines/' + frame_serial + '/servicerequest')
            .then(function(res) {
                return res.data;
            });
        },
        postNonconnectedServiceRequest: function(id, requestInfo) {
            return $http.post(apiUrl + '/nonconnected_machines/' + id + '/servicerequest', requestInfo)
            .then(function(res) {
                return res.data;
            });
        },
        getNonconnectedServiceRequests: function(id) {
            return $http.get(apiUrl + '/nonconnected_machines/' + id + '/servicerequest')
            .then(function(res) {
                return res.data;
            });
        },
        getFacilityServiceRequests: function(facility_id) {
            return $http.get(apiUrl + '/facilities/' + facility_id + '/servicerequest')
            .then(function(res) {
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/serviceRequest.js